import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { BookOpen } from 'lucide-react'

export default function LearningPlans() {
  const navigate = useNavigate()

  useEffect(() => {
    // Redirect to the new unified BuildingBlocks interface
    navigate('/building-blocks', { replace: true })
  }, [navigate])

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center">
        <BookOpen className="mx-auto h-12 w-12 text-gray-400" />
        <h3 className="mt-2 text-sm font-medium text-gray-900">Weiterleitung...</h3>
        <p className="mt-1 text-sm text-gray-500">
          Sie werden zur neuen einheitlichen Bausteine-Verwaltung weitergeleitet.
        </p>
      </div>
    </div>
  )
}
